export function moneyWithDecimalConvertor(
  plainMoney: number | undefined
): number {
  const conversionRate = 0.01;
  if (typeof plainMoney === 'number') {
    return plainMoney * conversionRate;
  }
  return 0;
}
